import {
  Box,
  Divider,
  IconButton,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverCloseButton,
  PopoverBody,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Button
} from '@chakra-ui/react'
import { format } from 'date-fns'
import { FC } from 'react'
import Chart from 'react-apexcharts'
import { GoGraph } from 'react-icons/go'
import { useImmer } from 'use-immer'

import useOptimizerStorange from '@hook/optimizer/use-optimizer-storange'

import { formatPercentOriginal, formatToBRL } from '@helper/grid/strings'

interface LineChartProps {
  dataTraderOff?: any // Ajuste o tipo conforme necessário
  indexStkOtimizar?: any
}

const LineChart: FC<LineChartProps> = ({
  dataTraderOff = null,
  indexStkOtimizar = null
}) => {
  const { resumoData } = useOptimizerStorange()
  let content: any[] = []

  if (dataTraderOff != null) {
    const content1 = [
      resumoData[0].otimizador < resumoData[0].realizado
        ? {
            name: 'Otimizador',
            data: [
              null,
              resumoData[0].otimizador < resumoData[0].realizado
                ? resumoData[1].otimizador * 100
                : null,
              resumoData[0].otimizador > resumoData[0].realizado
                ? resumoData[1].otimizador * 100
                : null,
              null
            ],
            color: '#04671a'
          }
        : {
            name: 'Realizado',
            data: [
              null,
              resumoData[0].realizado > resumoData[0].otimizador
                ? resumoData[1].realizado * 100
                : null,
              resumoData[0].realizado < resumoData[0].otimizador
                ? resumoData[1].realizado * 100
                : null,
              null
            ],
            color: '#f64223'
          },
      resumoData[0].otimizador < resumoData[0].realizado
        ? {
            name: 'Realizado',
            data: [
              null,
              resumoData[0].realizado < resumoData[0].otimizador
                ? resumoData[1].realizado * 100
                : null,
              resumoData[0].realizado > resumoData[0].otimizador
                ? resumoData[1].realizado * 100
                : null,
              null
            ],
            color: '#f64223'
          }
        : {
            name: 'Otimizador',
            data: [
              null,
              resumoData[0].otimizador < resumoData[0].realizado
                ? resumoData[1].otimizador * 100
                : null,
              resumoData[0].otimizador > resumoData[0].realizado
                ? resumoData[1].otimizador * 100
                : null,
              null
            ],
            color: '#04671a'
          }
    ]
    content = content1
  }

  // new

  const data = {
    options: {
      chart: {
        type: 'sccater'
      },
      xaxis: {
        // min: 0,
        // max: max + 3000000,
        categories: dataTraderOff.categoria,
        labels: {
          formatter: function (value: number) {
            return `R$ ${Number(value)
              .toFixed(2)
              .replace(/\d(?=(\d{3})+\.)/g, '$&,')}`
          }
        },
        title: {
          text: 'Estoque Médio [Custo (R$)]'
        }
      },
      yaxis: {
        labels: {
          formatter: function (value: number) {
            if (value !== null && value !== undefined) {
              return value?.toFixed(2) + ' %'
            }
          }
        },
        title: {
          text: 'Nível de Ruptura (%)'
        },
        tickAmount: 7
      },
      dataLabels: {
        enabled: false
      },
      markers: {
        size: [7, 7], // Tamanhos diferentes para cada série
        // colors: ['#FF0000', '#008000'], // Cores diferentes para cada série
        // strokeColors: ['#FF0000', '#008000'],
        fillOpacity: 1,
        strokeWidth: 2,
        hover: {
          sizeOffset: 6
        },
        discrete: [
          {
            // Posição 3 (índice 2) - Não mostrar marcador
            seriesIndex: 0,
            dataPointIndex: indexStkOtimizar,
            fillColor: 'transparent', // Torna o marcador invisível
            strokeColor: 'transparent' // Torna a borda invisível
          }
        ]
      },
      legend: {
        show: true,
        markers: {
          fillColors: ['#FF0000', '#008000']
        },
        offsetY: 10, // deslocamento vertical
        itemMargin: {
          horizontal: 10, // padding horizontal
          vertical: 12 // padding vertical
        }
      }
    },
    series: content
  }

  return (
    <Box w="full" p={5} shadow="md" borderWidth="1px" borderRadius="lg">
      <Chart
        options={data.options as any}
        series={dataTraderOff.series}
        type="line"
        height={440}
        id="chart-one"
        width={1050}
      />
    </Box>
  )
}

const HistoricOtptimizer: FC = () => {
  const { dataHistoric } = useOptimizerStorange()
  const [dataTradeOff, updateDataTradeOff] = useImmer<any>({})
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [indexStkOtimizar, setIndexStkOtimizar] = useImmer<number>(null)

  function insertSorted(arr: number[], num: number): number[] {
    if (arr.includes(num)) {
      return arr // Return the array as is if the number already exists
    }
    const index = arr.findIndex(el => el > num)
    if (index === -1) {
      arr.push(num) // If no element is greater, append at the end
    } else {
      arr.splice(index, 0, num) // Insert at the correct position
    }
    return arr
  }

  function interpolateNulls(data: (number | null)[]) {
    const result = [...data]
    for (let i = 0; i < result.length; i++) {
      if (result[i] === null) {
        // Encontrar os índices dos pontos antes e depois do null
        const prevIndex = i - 1
        const nextIndex = result.findIndex(
          (val, idx) => idx > i && val !== null
        )
        if (prevIndex >= 0 && nextIndex > i) {
          // Interpolação linear
          const prevValue = result[prevIndex]!
          const nextValue = result[nextIndex]!
          const step = (nextValue - prevValue) / (nextIndex - prevIndex)
          result[i] = prevValue + step * (i - prevIndex)
        }
      }
    }
    return result
  }

  const getLevelSelected = (level: any, index: any) => {
    // eslint-disable-next-line no-debugger
    if (level < index) {
      return level
    }
    return level + 1
  }
  const SendChatGraphOld = (data: any, point: any) => {
    let serie1 = data?.estoques?.map((x: any) => x.rupturaPercentual)
    // const serie2 = data?.estoques?.map((x: any) => x.rupturaPercentual)
    const categories1 = data?.estoques?.map((x: any) => x.estoqueReais)
    // console.log('trade off', data)
    let sortedArray = insertSorted(categories1, data?.estoqueAtual)
    sortedArray = insertSorted(categories1, data?.estoqueAOtimizar)

    const indice = sortedArray.indexOf(data?.estoqueAtual)

    const otimizadorGraph1: (number | null)[] = sortedArray.map((x, index) => {
      return index === indice ? data?.rupturaAtual : null
    })

    const indiceAOtimizar = sortedArray.indexOf(data?.estoqueAOtimizar)
    setIndexStkOtimizar(indiceAOtimizar)

    const otimizadorGraphAOtimizar: (number | null)[] = sortedArray.map(
      (x, index) => {
        return index === indiceAOtimizar ? data?.rupturaAOtimizar + 1 : null
      }
    )
    serie1.splice(indiceAOtimizar, 0, null)
    serie1 = interpolateNulls(serie1)
    const value = serie1[getLevelSelected(point, indiceAOtimizar)]

    const otimizadorGraph2: (number | null)[] = serie1.map(
      (x: any, index: any) => {
        return index === getLevelSelected(point, indiceAOtimizar) ? value : null
      }
    )
    // console.log('trade off1', data?.estoqueAtual)
    // console.log('trade off1', indice)
    // console.log('trade off1', closestIndex)
    // console.log('trade off1', categories1)
    // console.log('trade off1', sortedArray)
    // console.log('trade off1', otimizadorGraph1)
    updateDataTradeOff({
      categoria: categories1,
      series: [
        {
          name: 'Curva Trade Off',
          data: serie1,
          type: 'line',
          color: '#04671a'
        },
        {
          name: 'Stk Total',
          data: otimizadorGraph1,
          type: 'line',
          color: '#1b2310'
        },
        {
          name: 'Stk a Otimizar',
          data: otimizadorGraphAOtimizar,
          type: 'line',
          color: '#5e75d1'
        },
        {
          name: 'Otimizado',
          data: otimizadorGraph2,
          type: 'line',
          color: '#FFC300'
        }
      ]
    })
    onOpen()
  }

  // eslint-disable-next-line no-var
  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} size="6xl">
        <ModalOverlay />
        <ModalContent bg="white">
          <ModalHeader
            paddingTop={2}
            paddingBottom={2}
            paddingLeft={4}
            paddingRight={4}
            textColor={'gray.200'}
            background={'#1d5840'}
            borderTopLeftRadius={5}
            borderTopRightRadius={5}
            borderBottom="3px solid #ECC94B"
          >
            Grafico na Otimizacao
          </ModalHeader>
          <ModalCloseButton
            top={1}
            right={1.5}
            textColor={'gray.200'}
            size="lg"
          />
          <ModalBody>
            <LineChart
              dataTraderOff={dataTradeOff}
              indexStkOtimizar={indexStkOtimizar}
            />
          </ModalBody>
        </ModalContent>
      </Modal>
      <Box>
        <Divider />
        <Box p={4}>
          <Text fontSize={'md'}>
            <Text as="span" fontWeight="bold">
              Dados das últimas alterações:
            </Text>{' '}
            {dataHistoric.length > 0
              ? format(new Date(dataHistoric[0].data), 'dd/MM/yyyy HH:mm:ss')
              : ''}
          </Text>
          {/* <Text fontSize={'md'}>
            <Text as="span" fontWeight="bold">
              Otimizacoes:
            </Text>{' '}
            {dataHistoric.length}
          </Text>

          <Text fontSize={'md'}>
            <Text as="span" fontWeight="bold">
              Economia Prevista:
            </Text>{' '}
            {dataHistoric.length > 0
              ? formatToBRL(GetCalculateDifference())
              : 'R$ 0'}
          </Text> */}
        </Box>

        <Box p={4} pos="relative" h={580} maxW="100%" overflow="auto">
          <Table size="sm" className="scl-table-grid-v2">
            <Thead
              bg="#1d5840"
              color="white"
              border={10}
              h={10}
              fontWeight="700"
            >
              <Tr textTransform={'uppercase'}>
                <Th fontWeight="700" color="white" textTransform={'uppercase'}>
                  Empresa
                </Th>
                <Th fontWeight="700" color="white" textTransform={'uppercase'}>
                  Tipo CD
                </Th>
                <Th fontWeight="700" color="white" textTransform={'uppercase'}>
                  Centro
                </Th>
                <Th fontWeight="700" color="white" textTransform={'uppercase'}>
                  Mundo
                </Th>
                <Th fontWeight="700" color="white" textTransform={'uppercase'}>
                  Categoria Compacta
                </Th>{' '}
                <Th fontWeight="700" color="white" textTransform={'uppercase'}>
                  Sub Categoria
                </Th>
                <Th fontWeight="700" color="white" textTransform={'uppercase'}>
                  Curva
                </Th>
                <Th fontWeight="700" color="white" textTransform={'uppercase'}>
                  PONTO SELECIONADO
                </Th>
                <Th fontWeight="700" color="white" textTransform={'uppercase'}>
                  STK TOTAL
                </Th>
                <Th fontWeight="700" color="white" textTransform={'uppercase'}>
                  STK A OTIMIZAR
                </Th>
                <Th fontWeight="700" color="white" textTransform={'uppercase'}>
                  STK SELECIONADO
                </Th>
                <Th fontWeight="700" color="white" textTransform={'uppercase'}>
                  RUPTURA % ATUAL
                </Th>
                <Th fontWeight="700" color="white" textTransform={'uppercase'}>
                  RUPTURA % OTIMIZADA
                </Th>
                <Th fontWeight="700" color="white" textTransform={'uppercase'}>
                  Data Otimizacao
                </Th>
                <Th fontWeight="700" color="white" textTransform={'uppercase'}>
                  usuário
                </Th>
                <Th fontWeight="700" color="white" textTransform={'uppercase'}>
                  ação
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              {dataHistoric.length > 0 &&
                dataHistoric.map(value => (
                  <>
                    <Tr cursor="default">
                      <Td cursor="default">
                        {value?.filtros?.empresaId.length === 1 ? (
                          value?.filtros?.empresaId[0]
                        ) : (
                          <>
                            {value?.filtros?.empresaId[0]}
                            {value?.filtros?.empresaId.length > 1 && (
                              <Popover>
                                <PopoverTrigger>
                                  <Button
                                    size="sm"
                                    // variant="ghost"
                                    aria-label="More info"
                                    ml={2}
                                  >
                                    {' '}
                                    + {value?.filtros?.empresaId.length - 1}
                                  </Button>
                                </PopoverTrigger>
                                <PopoverContent>
                                  <PopoverArrow />
                                  <PopoverCloseButton />
                                  <PopoverBody bg="white">
                                    {value?.filtros?.empresaId
                                      .slice(1)
                                      .map((item, index) => (
                                        <Box key={index}>{item}</Box>
                                      ))}
                                  </PopoverBody>
                                </PopoverContent>
                              </Popover>
                            )}
                          </>
                        )}
                      </Td>
                      <Td cursor="default">
                        {value?.filtros?.tipoCentro.length === 1 ? (
                          value?.filtros?.tipoCentro[0]
                        ) : (
                          <>
                            {value?.filtros?.tipoCentro[0]}
                            {value?.filtros?.tipoCentro.length > 1 && (
                              <Popover>
                                <PopoverTrigger>
                                  <Button
                                    size="sm"
                                    // variant="ghost"
                                    aria-label="More info"
                                    ml={2}
                                  >
                                    {' '}
                                    + {value?.filtros?.tipoCentro.length - 1}
                                  </Button>
                                </PopoverTrigger>
                                <PopoverContent>
                                  <PopoverArrow />
                                  <PopoverCloseButton />
                                  <PopoverBody bg="white">
                                    {value?.filtros?.tipoCentro
                                      .slice(1)
                                      .map((item, index) => (
                                        <Box key={index}>{item}</Box>
                                      ))}
                                  </PopoverBody>
                                </PopoverContent>
                              </Popover>
                            )}
                          </>
                        )}
                      </Td>
                      <Td cursor="default">
                        {value?.filtros?.lojaId !== undefined &&
                        value?.filtros?.lojaId?.length === 1 ? (
                          value?.filtros?.lojaId[0]
                        ) : (
                          <>
                            {value?.filtros?.lojaId !== undefined &&
                              value?.filtros?.lojaId[0]}
                            {value?.filtros?.lojaId !== undefined &&
                              value?.filtros?.lojaId.length > 1 && (
                                <Popover>
                                  <PopoverTrigger>
                                    <Button
                                      size="sm"
                                      // variant="ghost"
                                      aria-label="More info"
                                      ml={2}
                                    >
                                      {' '}
                                      + {value?.filtros?.lojaId.length - 1}
                                    </Button>
                                  </PopoverTrigger>
                                  <PopoverContent>
                                    <PopoverArrow />
                                    <PopoverCloseButton />
                                    <PopoverBody bg="white">
                                      {value?.filtros?.lojaId
                                        .slice(1)
                                        .map((item, index) => (
                                          <Box key={index}>{item}</Box>
                                        ))}
                                    </PopoverBody>
                                  </PopoverContent>
                                </Popover>
                              )}
                          </>
                        )}
                      </Td>
                      <Td cursor="default">
                        {value?.filtros?.mundoId.length === 1 ? (
                          value?.filtros?.mundoId[0]
                        ) : (
                          <>
                            {value?.filtros?.mundoId[0]}
                            {value?.filtros?.mundoId.length > 1 && (
                              <Popover>
                                <PopoverTrigger>
                                  <Button
                                    size="sm"
                                    // variant="ghost"
                                    aria-label="More info"
                                    ml={2}
                                  >
                                    {' '}
                                    + {value?.filtros?.mundoId.length - 1}
                                  </Button>
                                </PopoverTrigger>
                                <PopoverContent>
                                  <PopoverArrow />
                                  <PopoverCloseButton />
                                  <PopoverBody bg="white">
                                    {value?.filtros?.mundoId
                                      .slice(1)
                                      .map((item, index) => (
                                        <Box key={index}>{item}</Box>
                                      ))}
                                  </PopoverBody>
                                </PopoverContent>
                              </Popover>
                            )}
                          </>
                        )}
                      </Td>
                      <Td cursor="default">
                        {value?.filtros?.categoriaCompactaId.length === 1 ? (
                          value?.filtros?.categoriaCompactaId[0]
                        ) : (
                          <>
                            {value?.filtros?.categoriaCompactaId[0]}
                            {value?.filtros?.categoriaCompactaId.length > 1 && (
                              <Popover>
                                <PopoverTrigger>
                                  <Button
                                    size="sm"
                                    // variant="ghost"
                                    aria-label="More info"
                                    ml={2}
                                  >
                                    {' '}
                                    +{' '}
                                    {value?.filtros?.categoriaCompactaId
                                      .length - 1}
                                  </Button>
                                </PopoverTrigger>
                                <PopoverContent>
                                  <PopoverArrow />
                                  <PopoverCloseButton />
                                  <PopoverBody bg="white">
                                    {value?.filtros?.categoriaCompactaId
                                      .slice(1)
                                      .map((item, index) => (
                                        <Box key={index}>{item}</Box>
                                      ))}
                                  </PopoverBody>
                                </PopoverContent>
                              </Popover>
                            )}
                          </>
                        )}
                      </Td>
                      <Td cursor="default">
                        {Array.isArray(value?.filtros?.subCategoriaId) &&
                        value.filtros.subCategoriaId.length > 0 ? (
                          value.filtros.subCategoriaId.length === 1 ? (
                            value.filtros.subCategoriaId[0]
                          ) : (
                            <>
                              {value.filtros.subCategoriaId[0]}
                              <Popover>
                                <PopoverTrigger>
                                  <Button size="sm" ml={2}>
                                    +{value.filtros.subCategoriaId.length - 1}
                                  </Button>
                                </PopoverTrigger>
                                <PopoverContent>
                                  <PopoverArrow />
                                  <PopoverCloseButton />
                                  <PopoverBody bg="white">
                                    {value.filtros.subCategoriaId
                                      .slice(1)
                                      .map((item, index) => (
                                        <Box key={index}>{item}</Box>
                                      ))}
                                  </PopoverBody>
                                </PopoverContent>
                              </Popover>
                            </>
                          )
                        ) : (
                          <>–</> // ou null ou alguma mensagem como "Nenhuma subcategoria"
                        )}
                      </Td>

                      <Td cursor="default">
                        {value?.filtros?.curva !== undefined &&
                        value?.filtros?.curva?.length === 1 ? (
                          value?.filtros?.curva[0]
                        ) : (
                          <>
                            {value?.filtros?.curva !== undefined &&
                              value?.filtros?.curva[0]}
                            {value?.filtros?.curva !== undefined &&
                              value?.filtros?.curva.length > 1 && (
                                <Popover>
                                  <PopoverTrigger>
                                    <Button
                                      size="sm"
                                      // variant="ghost"
                                      aria-label="More info"
                                      ml={2}
                                    >
                                      {' '}
                                      + {value?.filtros?.curva.length - 1}
                                    </Button>
                                  </PopoverTrigger>
                                  <PopoverContent>
                                    <PopoverArrow />
                                    <PopoverCloseButton />
                                    <PopoverBody bg="white">
                                      {value?.filtros?.curva
                                        .slice(1)
                                        .map((item, index) => (
                                          <Box key={index}>{item}</Box>
                                        ))}
                                    </PopoverBody>
                                  </PopoverContent>
                                </Popover>
                              )}
                          </>
                        )}
                      </Td>
                      <Td cursor="default">{value?.ponto}</Td>
                      <Td cursor="default">
                        {formatToBRL(value?.estoqueAnterior)}
                      </Td>
                      <Td cursor="default">
                        {' '}
                        {formatToBRL(value?.estoqueAOtimizar)}
                      </Td>
                      <Td cursor="default">
                        {formatToBRL(value?.estoqueNovo)}
                      </Td>
                      <Td cursor="default">
                        {formatPercentOriginal(
                          value?.rupturaPercentualAnterior
                        )}
                      </Td>
                      <Td cursor="default">
                        {formatPercentOriginal(value?.rupturaPercentualNovo)}
                      </Td>
                      <Td cursor="default">
                        {format(new Date(value?.data), 'dd/MM/yyyy HH:mm:ss')}
                      </Td>
                      <Td cursor="default">{value?.login}</Td>
                      <Td cursor="default">
                        {' '}
                        <IconButton
                          aria-label="Graph Icon"
                          icon={<GoGraph />}
                          onClick={() => {
                            SendChatGraphOld(value?.curvaTradeOff, value?.ponto)
                          }}
                          variant="unstyled" // Isso remove o estilo padrão do botão
                        />
                      </Td>
                    </Tr>
                  </>
                ))}
            </Tbody>
          </Table>
        </Box>
      </Box>
    </>
  )
}
export default HistoricOtptimizer
